import PhotoSwipe from 'photoswipe';
import PhotoSwipeUIDefault from 'photoswipe/dist/photoswipe-ui-default.js';

export function initLightboxGallery(gallerySelector) {
	// parse slide data (url, title, size ...) from DOM elements
	// (children of gallerySelector)
	var parseThumbnailElements = function(el) {
		var figureEl;
		var linkEl;
		var imgEl;
		var items = [];
		var item;
		var size;

		var prepareItem = function(thumb) {
			figureEl = thumb;

			// include only element nodes
			if (figureEl.nodeType !== 1) {
				return;
			}

			linkEl = figureEl.getElementsByTagName('a')[0];

			if (!linkEl) {
				return;
			}

			imgEl = figureEl.getElementsByTagName('img')[0];

			size = imgEl.getAttribute('data-pswp-size').split('x');

			item = {
				src: linkEl.getAttribute('href'),
				w: parseInt(size[0], 10),
				h: parseInt(size[1], 10)
			};

			if (figureEl.children.length > 1) {
				item.title = figureEl.children[1].innerHTML;
			}

			item.el = figureEl; // save link to element for getThumbBoundsFn
			items.push(item);
		};

		// if a single figure
		if (el.tagName && el.tagName.toUpperCase() === 'FIGURE') {
			prepareItem(el);
		} else {
			var thumbElements = el.childNodes;
			var numNodes = thumbElements.length;

			for (var i = 0; i < numNodes; i++) {
				prepareItem(thumbElements[i]);
			}
		}

		return items;
	};

	// find nearest parent element
	var closest = function closest(el, fn) {
		return el && (fn(el) ? el : closest(el.parentNode, fn));
	};

	// triggers when user clicks on thumbnail
	var onThumbnailsClick = function(e) {
		e = e || window.event;
		e.preventDefault ? e.preventDefault() : (e.returnValue = false);

		var eTarget = e.target || e.srcElement;

		// find root element of slide
		var clickedListItem = closest(eTarget, function(el) {
			return el.tagName && el.tagName.toUpperCase() === 'FIGURE';
		});

		if (!clickedListItem) {
			return;
		}

		// find index of clicked item by looping through all child nodes
		// alternatively, you may define index via data- attribute
		var isGallery = clickedListItem.parentNode.className.indexOf('gallery') > -1;

		var clickedGallery = isGallery ? clickedListItem.parentNode : clickedListItem;
		var childNodes = isGallery ? clickedGallery.childNodes : null;

		if (!childNodes) {
			openPhotoSwipe(0, clickedGallery);
		} else {
			var numChildNodes = childNodes.length;
			var nodeIndex = 0;
			var index;

			for (var i = 0; i < numChildNodes; i++) {
				if (childNodes[i].nodeType !== 1) {
					continue;
				}

				if (childNodes[i] === clickedListItem) {
					index = nodeIndex;
					break;
				}
				nodeIndex++;
			}

			if (index >= 0) {
				// open PhotoSwipe if valid index found
				openPhotoSwipe(index, clickedGallery);
			}
		}

		return false;
	};

	// parse picture index and gallery index from URL (#&pid=1&gid=2)
	var photoswipeParseHash = function() {
		var hash = window.location.hash.substring(1);
		var params = {};

		if (hash.length < 5) {
			return params;
		}

		var vars = hash.split('&');
		for (var i = 0; i < vars.length; i++) {
			if (!vars[i]) {
				continue;
			}

			var pair = vars[i].split('=');
			if (pair.length < 2) {
				continue;
			}
			params[pair[0]] = pair[1];
		}

		if (params.gid) {
			params.gid = parseInt(params.gid, 10);
		}

		return params;
	};

	var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
		var pswpElement = document.querySelectorAll('.pswp')[0];
		var gallery;
		var options;
		var items;

		items = parseThumbnailElements(galleryElement);

		if (!items.length) {
			return;
		}

		// define options (if needed)
		options = {
			// define gallery index (for URL)
			galleryUID: galleryElement.getAttribute('data-pswp-uid'),
			showHideOpacity: true,
			getThumbBoundsFn: false,
			shareButtons: [
				{ id: 'facebook', label: 'Dela på Facebook', url: 'https://www.facebook.com/sharer/sharer.php?u={{url}}' },
				{ id: 'twitter', label: 'Tweeta', url: 'https://twitter.com/intent/tweet?text={{text}}&url={{url}}' },
				{
					id: 'pinterest',
					label: 'Pinna',
					url: 'http://www.pinterest.com/pin/create/button/?url={{url}}&media={{image_url}}&description={{text}}'
				},
				{ id: 'download', label: 'Ladda ned', url: '{{raw_image_url}}', download: true }
			]
		};

		// PhotoSwipe opened from URL
		if (fromURL) {
			if (options.galleryPIDs) {
				// parse real index when custom PIDs are used
				// http://photoswipe.com/documentation/faq.html#custom-pid-in-url
				for (var j = 0; j < items.length; j++) {
					if (items[j].pid === index) {
						options.index = j;
						break;
					}
				}
			} else {
				// in URL indexes start from 1
				options.index = parseInt(index, 10) - 1;
			}
		} else {
			options.index = parseInt(index, 10);
		}

		// exit if index not found
		if (isNaN(options.index)) {
			return;
		}

		if (disableAnimation) {
			options.showAnimationDuration = 0;
		}

		// Pass data to PhotoSwipe and initialize it
		/* eslint-disable */
		gallery = new PhotoSwipe(pswpElement, PhotoSwipeUIDefault, items, options);
		/* eslint-enable */
		gallery.init();
		// Image loaded
		gallery.listen('imageLoadComplete', function(index, item) {
			item.container.classList.add('pswp__zoom-wrap--loaded');
		});
	};

	// loop through all gallery elements and bind events
	var galleryElements = document.querySelectorAll(gallerySelector);
	var uidStartingId = gallerySelector === '.gallery' ? 1 : 999;

	for (var i = 0, l = galleryElements.length; i < l; i++) {
		galleryElements[i].setAttribute('data-pswp-uid', i + uidStartingId);
		galleryElements[i].onclick = onThumbnailsClick;
	}

	// Parse URL and open gallery if it contains #&pid=3&gid=1
	var hashData = photoswipeParseHash();
	if (hashData.pid && hashData.gid && galleryElements[hashData.gid - uidStartingId]) {
		openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - uidStartingId], true, true);
	}
}
